import React, { useContext, useEffect, useState } from "react";
import { Form, Checkbox } from "antd";
import { traumaOptions } from "../../Options/clinicalImpressionOptions";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const Trauma = ({ context, form }) => {
  const { formData } = useContext(context);
  const traumaData =
    formData?.clinical_diagnosis?.trauma_diagnosis ||
    formData?.trauma_diagnosis;
  const [showTraumaOthers, setShowTraumaOthers] = useState(
    traumaData?.includes("others")
  );

  const handleTraumaChange = (selectedOptions) => {
    setShowTraumaOthers(selectedOptions?.includes("others"));
  };

  useEffect(() => {
    setShowTraumaOthers(traumaData?.includes("others"));
  }, [formData]);

  return (
    <>
      <Form.Item name="trauma_diagnosis" label="Trauma Diagnosis">
        <Checkbox.Group options={traumaOptions} onChange={handleTraumaChange} />
      </Form.Item>
      {showTraumaOthers && (
        <DynamicInputFields
          field_key={"trauma_diagnosis_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default Trauma;
